import { Component, inject, OnInit } from '@angular/core';

import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {CommonModule} from '@angular/common';

import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

import { CreateUserPayload } from '@shared/interfacres/user';
import { UserData } from '@shared/components/user-data/user-data';
import { MatCheckbox } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { UsersStore } from '@data-access/user/stores/users.store';
import { firstValueFrom } from 'rxjs';
import { mapFormToPayload, UserDataFormValue } from '@shared/helpers/user-form-to-payload';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { confirmPasswordValidator } from '@shared/validators/password-match.validator';
import { MatDialog } from '@angular/material/dialog';
// import { PlanSelectDialog } from '@shared/components/plan-select-dialog/plan-select-dialog';



@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [
    CommonModule,

    ReactiveFormsModule,

    MatIcon,
    MatButton,

    UserData,
    MatCheckbox,
    RouterLink,
    MatProgressSpinner,
  ],
  templateUrl: './signup.html',
  styleUrl: './signup.scss'
})
export class Signup implements OnInit {
  isPasswordShown = false;

  userStore = inject(UsersStore);
  // route = inject(ActivatedRoute);

  fb = inject(FormBuilder);
  disabled = false;

  mode: 'form' | 'message' | 'loading' = 'form';
  // successMessage = '';
  readonly dialog = inject(MatDialog);

  // selectedPlanId: string | null = null;
  // plans: SubscriptionPlan[] = [];
  //
  // selectedPlanData: SubscriptionPlan | null = null;

  form = this.fb.group({
    email: new FormControl('', [Validators.required, Validators.email], []),
    password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).*$/)]),
    passwordConfirm: new FormControl(''),
    newsSubscribe: new FormControl(false, [Validators.requiredTrue]),
    // promoCode:  new FormControl(''),
    userData: {
      firstName: '',
      lastName: '',
      stageName: '',

      // performanceType: '',
      performanceType: [],
      weeklyPerformances: null,

      website: '',
      instagram: '',
      facebook: '',

      performanceLocations1: '',
      performanceLocations2: '',
      performanceLocations3: '',
      // temps: []
    },
  }, { validators: confirmPasswordValidator })

  performanceTypes: string[] = [];

  async ngOnInit() {
    // this.plans = await firstValueFrom(this.userStore.getPlans());

    // this.route.snapshot.queryParams['product_id']
    this.performanceTypes = await firstValueFrom(this.userStore.getPerformanceTypes());
    // this.selectedPlanId = this.route.snapshot.queryParams['product_id'];
    // if (!this.selectedPlanId) {
    //   this.showPlanSelectionDialog();
    // } else {
    //   // verify is received plan valid
    //
    //   const selectedPlan = this.plans.find((plan: SubscriptionPlan) => plan.product.id === this.selectedPlanId);
    //   if (!selectedPlan) {
    //     this.selectedPlanId = null;
    //     this.showPlanSelectionDialog();
    //   } else {
    //     this.selectedPlanData = selectedPlan;
    //   }
    // }

  }

  // async showPlanSelectionDialog() {
  //
  //   const dialogRef = this.dialog.open(PlanSelectDialog, {
  //     data: {
  //       plans: this.plans,
  //       showCancel: true,
  //       activePlanId: this.selectedPlanId
  //     },
  //     disableClose: true,
  //     width: '85%',
  //     maxWidth: '1500px',
  //     panelClass: 'admin-dialog',
  //     backdropClass: 'admin-dialog-backdrop'
  //   });
  //
  //   const result = await firstValueFrom(dialogRef.afterClosed());
  //   if (result) {
  //     this.selectedPlanId = result;
  //     this.selectedPlanData = this.plans.find((plan: SubscriptionPlan) => plan.product.id === this.selectedPlanId) as SubscriptionPlan;
  //   }
  // }

  async save() {
    this.mode = 'loading';

    const signUpPayload: CreateUserPayload = {
      ...mapFormToPayload(this.form.value.userData as unknown as UserDataFormValue),
      email: this.form.value.email?.toLowerCase() || '',
      password: this.form.value.password || '',
    } as CreateUserPayload;

    const result = await this.userStore.create(signUpPayload);
    if (result && result.message === 'User and profile created successfully') {
      this.mode = 'message';
      // this.successMessage = result.message;
    } else {
      this.mode = 'form';
    }
  }
}


